import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GUEST_STORAGE_KEY = 'guest';

var dataOrDefault = function dataOrDefault(data, defaultValue) {
  return (data === null || typeof data === 'undefined') && typeof defaultValue !== 'undefined' ? defaultValue : data;
};

export var readStorage = function readStorage(type, name, defaultValue) {
  var raw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    var rawData = window[type].getItem(name);
    var data = raw ? rawData : JSON.parse(rawData);
    return dataOrDefault(data, defaultValue);
  } catch (e) {
    return defaultValue;
  }
};
export var readStorageForUser = function readStorageForUser(type, name, userId, defaultValue) {
  var data = readStorage(type, name, {})[userId || GUEST_STORAGE_KEY];
  return dataOrDefault(data, defaultValue);
};
export var writeStorage = function writeStorage(type, name, data) {
  var raw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    window[type].setItem(name, raw ? data : JSON.stringify(data));
  } catch (e) {
    /* noop */
  }
};
export var writeStorageForUser = function writeStorageForUser(type, name, data, userId) {
  return writeStorage(type, name, _objectSpread({}, readStorage(type, name, {}), _defineProperty({}, userId || GUEST_STORAGE_KEY, data)));
};
export var removeStorage = function removeStorage(type, name) {
  try {
    window[type].removeItem(name);
  } catch (e) {
    /* noop */
  }
};
export var removeStorageForUser = function removeStorageForUser(type, name, userId) {
  var data = readStorage(type, name, {});
  delete data[userId || GUEST_STORAGE_KEY];

  if (Object.keys(data) === 0) {
    removeStorage(type, name);
  } else {
    writeStorage(type, name, data);
  }
};
var LOCAL = 'localStorage';
var SESSION = 'sessionStorage';
export var readLocalStorage = readStorage.bind(null, LOCAL);
export var readLocalStorageForUser = readStorageForUser.bind(null, LOCAL);
export var writeLocalStorage = writeStorage.bind(null, LOCAL);
export var writeLocalStorageForUser = writeStorageForUser.bind(null, LOCAL);
export var removeLocalStorage = removeStorage.bind(null, LOCAL);
export var removeLocalStorageForUser = removeStorageForUser.bind(null, LOCAL);
export var readSessionStorage = readStorage.bind(null, SESSION);
export var readSessionStorageForUser = readStorageForUser.bind(null, SESSION);
export var writeSessionStorage = writeStorage.bind(null, SESSION);
export var writeSessionStorageForUser = writeStorageForUser.bind(null, SESSION);
export var removeSessionStorage = removeStorage.bind(null, SESSION);
export var removeSessionStorageForUser = removeStorageForUser.bind(null, SESSION);